export default {
	permissionsChecked: []
};
